import { SxProps, Theme } from "@mui/material/styles";

const styles: Record<string, SxProps<Theme>> = {
  paper: {
    borderRadius: "12px",
  },
  content: {
    backgroundColor: "background.paper",
    p: 3,
    width: { xs: "100%", sm: "auto" },
    height: { xs: "100vh", sm: "auto" },
    position: "relative",
  },
  close: {
    position: "absolute",
    zIndex: 10,
    right: (theme) => theme.spacing(2),
    top: (theme) => theme.spacing(2),
    fill: "none",
    color: (theme) => theme.palette.grey[500],
  },
  title: {
    fontWeight: "600",
    fontSize: "24px",
    lineHeight: "34px"
  },
  divider: {
    "& svg": {
      margin: "24px 0",
    }
  }
};

export default styles;
